import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Images, PermissionList, RolePermission, useModal } from 'utils';
import { NameAndAvatar, CustomDelete, UserInputsDropdown, PhoneBadge, EmailBadge, AddressBadge } from 'components';
import { CreateFundingSource } from '../../createFundingSource';
import { fundingSourceActions } from 'store';
import { FS_STATUSES } from './constants';
import {renderPayerEnrollment} from "../../../../pages/fundingSource/constants";

const ACTION_TYPE = 'DELETE_FUNDING_SOURCE';
const STATUS_ACTION_TYPE = 'DELETE_FUNDING_SOURCE';
export const FundingSourceSingleHeader = ({}) => {
    const dispatch = useDispatch();
    const params = useParams();
    const fsSource = useSelector((state) => state.fundingSource.fundingSourceItem);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();

    const handleChangeStatus = (currentStatus) => {
        dispatch(fundingSourceActions.changeFundingSourceStatus(params.id, currentStatus?.status));
    };

    return (
        <div className="tabs-wrapper">
            <div className="full-width">
                <div className="space-between-flex-start">
                    <NameAndAvatar
                        src={Images.fsIcon}
                        name={fsSource?.name}
                        imageStyles={{ minWidth: 24, width: 24, height: 24}}
                        nameSuffix={renderPayerEnrollment(fsSource)}
                    >
                        <div className="flex-align-center" style={{ gap: 12 }}>
                            {fsSource?.phoneNumber && <PhoneBadge phone={fsSource?.phoneNumber} />}
                            {fsSource?.email && <EmailBadge email={fsSource?.email} />}
                            {fsSource?.address?.formattedAddress && <AddressBadge address={fsSource?.address} poBox={fsSource?.poBox} />}
                        </div>
                    </NameAndAvatar>
                    <div className="flex-align-start" style={{ gap: 16 }}>
                        {RolePermission([PermissionList.FS_STATUS?.code]) && (
                            <UserInputsDropdown
                                dropdownOptions={FS_STATUSES}
                                actionType={STATUS_ACTION_TYPE}
                                selected={fsSource?.status}
                                onPass={handleChangeStatus}
                                type={'Fs Source'}
                            />
                        )}

                        {info?.activeTab === 'General' || info?.activeTab === undefined ? (
                            <div className="flex-align-center" style={{ gap: '16px' }}>
                                {RolePermission([PermissionList.FS_CREATE?.code]) && (
                                    <button className="table-action-btn" onClick={() => open(<CreateFundingSource info={fsSource} />)}>
                                        <img src={Images.edit} alt="icon" />
                                    </button>
                                )}

                                {fsSource?.canDelete && RolePermission([PermissionList.FS_DELETE?.code]) && (
                                    <button
                                        className="table-action-btn"
                                        onClick={() =>
                                            open(
                                                <CustomDelete
                                                    text={`Deleting this funding source will permanently remove it from the system.`}
                                                    info="Are you sure you want to delete this funding source?"
                                                    innerText={'Delete'}
                                                    handleDel={() => dispatch(fundingSourceActions.deleteFundingSource(fsSource?.id))}
                                                    actionType={ACTION_TYPE}
                                                    afterSuccess={() => navigate('/fundingSource')}
                                                />
                                            )
                                        }
                                    >
                                        <img src={Images.redTrash} alt={'icon'} />
                                    </button>
                                )}
                            </div>
                        ) : (
                            // info?.activeTab === 'History' ? (
                            //         <SearchHistory />
                            //     ) :
                            // info?.activeTab === 'Services' && RolePermission([PermissionList.FS_SERVICE_CREATE?.code]) ?
                            //     <AddButton
                            //         text={'Add Service'}
                            //         handleClick={() => open(<FundingSourceServiceAdd />)}
                            //     />
                            //     :
                            //     info?.activeTab === 'Notes' && RolePermission([PermissionList.FS_NOTE_MANAGE?.code]) ?
                            //         <AddButton
                            //             text={'Add Note'}
                            //             handleClick={() => open(<AddNotes model="Funder" id={fsSource?.id} />)}
                            //         />
                            //         :
                            //         info?.activeTab === 'Files' && RolePermission([PermissionList.FS_FILE_MANAGE?.code]) ?
                            //             <AddButton
                            //                 Icon={true}
                            //                 customIcon={Images.uploadCloud}
                            //                 text={'Upload Document'}
                            //                 handleClick={() => open(
                            //                     <UploadModal
                            //                         currentId={fsSource?.id}
                            //                         onResource={'fs'}
                            //                     />,
                            //                 )}
                            //             />
                            //             :
                            <div />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
